module.exports = __webpack_public_path__ + "static/media/featured_img_two copy.a38b1278.png";